<template>
  <el-dialog
    title="Relatórios de Clientes - Aluguel"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    @open="reset"
    width="35%"
    :close-on-click-modal="false"
  >
    <el-form
      :model="relatorio"
      :rules="validacao"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              @change="limparFiltros"
              clearable
              placeholder="Selecione o Relatório"
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="exibirCamposContatosRealizados" :gutter="24">
        <el-col :span="8">
          <el-form-item label="Status" style="font-weight: bold;">
            <el-select
              auto-complete="off"
              clearable
              v-model="relatorio.pretendente.status"
              style="width: 100%;"
            >
              <el-option label="Todos" value="TODOS"></el-option>
              <el-option
                v-for="item in statusPretendentes"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Data Inicial" prop="dataInicial" style="font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Data Final" prop="dataFinal" style="font-weight: bold;">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="exibirCamposCliente">
      <span>Categoria do Cliente</span>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item prop="categoriasClientes">
              <el-checkbox-group v-model="relatorio.categoriasClientes">
                <el-checkbox label="PROPRIETARIO">Proprietário</el-checkbox>
                <el-checkbox label="LOCATARIO">Locatário</el-checkbox>
                <el-checkbox label="FIADOR">Fiador</el-checkbox>
                <el-checkbox label="BENEFICIARIO">Beneficiário</el-checkbox>
                <el-checkbox label="PRETENDENTE">Pretendente</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <span> </span>
            <el-radio v-model="relatorio.xls" :label="false">PDF</el-radio>
            <el-radio v-model="relatorio.xls" :label="true">Excel</el-radio>
          </el-col>
        </el-row>
      </div>
      <p/>

      <el-row :gutter="24" v-if="exibirCamposCliente">
        <el-col :span="12">
          <el-form-item label="Data Inicial" prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Data Final" prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <div v-if="exibirCamposCliente">
        <span>Faixa de Renda</span>
        <el-row :gutter="24">
          <el-col :span="0.01">
            <p></p>
            <span>de</span>
          </el-col>
          <el-col :span="9">
            <el-form-item label prop="rendaInicial">
              <money v-model="relatorio.rendaInicial" v-bind="money" class="el-input__inner"/>
            </el-form-item>
          </el-col>
          <el-col :span="0.01">
            <p></p>
            <span>até</span>
          </el-col>
          <el-col :span="9">
            <el-form-item label prop="rendaFinal">
              <money v-model="relatorio.rendaFinal" v-bind="money" class="el-input__inner"/>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <p/>

      <div v-if="exibirCamposCliente">
        <span>Tipo</span>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-radio-group v-model="relatorio.personalidadeJuridica" label="Tipo" style="font-size: small;">
              <el-radio label="TODOS">Todos</el-radio>
              <el-radio label="PESSOA_FISICA">Pessoa Física</el-radio>
              <el-radio label="PESSOA_JURIDICA">Pessoa Jurídica</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <p/>

      <div v-if="exibirCamposCliente">
        <span v-if="exibirCamposPessoaFisica">Sexo</span>
        <el-row v-if="exibirCamposPessoaFisica" :gutter="20">
          <el-col :span="20">
            <el-radio-group v-model="relatorio.sexo" label="Sexo">
              <el-radio label="TODOS">Todos</el-radio>
              <el-radio label="MASCULINO">Masculino</el-radio>
              <el-radio label="FEMININO">Feminino</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <p/>

      <el-row :gutter="24" v-if="exibirCamposCliente">
        <el-col :span="24">
          <el-form-item label="Bairro do Cliente">
            <el-input v-model="relatorio.bairro"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="exibirCamposContatosRealizados">
        <el-col :span="24">
          <el-form-item label="Cliente" style="font-weight: bold;">
            <el-select
              v-model="relatorio.pretendente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="limparCampoPretendente"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="relatorio.nome">
        <el-col :span="24">
          <el-form-item label="Atendente">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="exibirCamposCliente"> 
        <span>Status do Contrato</span>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-radio-group v-model="relatorio.statusAluguel" style="font-size: small;">
              <el-radio label="TODOS">Todos</el-radio>
              <el-radio label="PENDENTE">Pendente</el-radio>
              <el-radio label="NOVO">Novo</el-radio>
              <el-radio label="APROVADO">Aprovado</el-radio>
              <el-radio label="EM_DESOCUPACAO">Em Desocupação</el-radio>
              <el-radio label="FINALIZADO">Finalizado</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";
import funcoes from "../../../util/funcoes.js";
import { STATUS_LISTA_ESPERA_PRETENDENTES } from "../../../util/constantes.js";

export default {
  props: {
    visibility: Boolean
  },
  components: {
    Money
  },
  data() {
    return {
      relatorio: {
        nome: "",
        pretendente: {
          id: 0,
          operacao: "ALUGUEL",
          status: 'TODOS',
          bairro: {}
        },
        cliente: {},
        personalidadeJuridica: "TODOS",
        statusAluguel: 'TODOS',
        sexo: "TODOS",
        bairro: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        rendaInicial: "",
        rendaFinal: "",
        categoriasClientes: ['PROPRIETARIO','LOCATARIO','FIADOR','BENEFICIARIO','PRETENDENTE'],
        xls: false
      },

      tiposRelatorios: [
        {
          value: "CLIENTES_ALUGUEL",
          label: "Clientes Cadastrados"
        },
        {
          value: "CONTATO_REALIZADO",
          label: "Contatos Realizados"
        }
      ],

      loadingClientes: false,
      loadingUsuarios: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      validacao: {
        categoriasClientes: [{ type: 'array', required: true }]
      }
    };
  },
  computed: {
    ...mapState("alugueisRelatoriosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      },
      clientesDisponiveis(state) {
        return state.clientesDisponiveis;
      }
    }),
    statusPretendentes() { return STATUS_LISTA_ESPERA_PRETENDENTES },

    exibirCamposPessoaFisica() {
      return this.relatorio.personalidadeJuridica == "PESSOA_FISICA";
    },
    exibirCamposCliente(){
      return this.relatorio.nome === "CLIENTES_ALUGUEL"
    },
    exibirCamposContatosRealizados(){
      return this.relatorio.nome === "CONTATO_REALIZADO"
    }
      
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisRelatoriosStore", ["gerarRelatorio", "listarUsuarios", "listarClientes"]),
    gerar() {
      this.$refs["form"].validate(elFormValidation => {
        const formIsInvalid = !elFormValidation;
        if(formIsInvalid) {
          this.$message.warning("Obrigatório pelo menos uma categoria de cliente.");
          return;
        }
        
        const payload = Object.assign({}, this.relatorio);
        delete payload.pretendente;
        
        if(this.exibirCamposContatosRealizados){
          delete payload.categoriasClientes;
          this.relatorio.pretendente = {
            status: this.relatorio.pretendente.status,
            operacao: this.relatorio.pretendente.operacao,
            bairro: this.relatorio.pretendente.bairro,
            id: this.relatorio.pretendente.id
          }   
          if(this.relatorio.pretendente && this.relatorio.pretendente.id !== 0) {
            this.relatorio.cliente.id = this.relatorio.pretendente.id
          }

          if (this.relatorio.pretendente.status === 'TODOS') { delete this.relatorio.pretendente.status }

        }else{
          delete payload.cliente;
        }
        if(payload.personalidadeJuridica == 'TODOS') { delete payload.personalidadeJuridica; }
        if(payload.personalidadeJuridica == 'PESSOA_JURIDICA') { delete payload.sexo; }
        if(payload.statusAluguel == 'TODOS') { delete payload.statusAluguel; }
        if(payload.sexo == 'TODOS') { delete payload.sexo; }
        if(payload.rendaInicial == 0) { delete payload.rendaInicial; }
        if(payload.rendaFinal == 0) { delete payload.rendaFinal; }
  
          this.showLoading();
          this.gerarRelatorio(payload)
            .then((resultado) => {
              this.hideLoading();
              if (resultado.status == "SUCESSO") {
                window.open(resultado.mensagem, "_blank");
              }
            })
            .catch(() => {
              this.hideLoading();
              this.$message.error("Não foi possível comunicar-se com o servidor");
            });
      });
    },
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    filtrarClientesSelect(queryString) {
      let payload = { categoriaPesquisa: 'PRETENDENTE' };

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        })
        .catch(() => {
          this.loadingUsuarios = false;
        });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    limparCampoPretendente() {
      this.relatorio.pretendente = {
        id: 0,
        operacao: "ALUGUEL",
        status: 'TODOS',
        bairro: {}
      }
    },
    limparFiltros(){
      this.relatorio = {
        nome: this.relatorio.nome,
        pretendente: {
          id: 0,
          operacao: "ALUGUEL",
          status: 'TODOS',
          bairro: {}
        },
        cliente: {},
        personalidadeJuridica: "TODOS",
        statusAluguel: 'TODOS',
        sexo: "TODOS",
        bairro: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        rendaInicial: "",
        rendaFinal: "",
        categoriasClientes: ['PROPRIETARIO','LOCATARIO','FIADOR','BENEFICIARIO','PRETENDENTE'],
        xls: false
      }
    },
    reset(){
      this.relatorio = {
        nome: "",
        pretendente: {
          id: 0,
          operacao: "ALUGUEL",
          status: 'TODOS',
          bairro: {}
        },
        cliente: {},
        personalidadeJuridica: "TODOS",
        statusAluguel: 'TODOS',
        sexo: "TODOS",
        bairro: undefined,
        usuario: undefined,
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        rendaInicial: "",
        rendaFinal: "",
        categoriasClientes: ['PROPRIETARIO','LOCATARIO','FIADOR','BENEFICIARIO','PRETENDENTE'],
        xls: false
      }
    },
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>